/**
 * 基础数据默认值
 * @param configCode
 * @param field
 * @param callback
 */
export function initDefaultValue (configCode, field = 'form', callback) {
    this.etao.requests.get({
        url: '/etao-basic/basic-default-config/get-default-config-code',
        data: { configCode },
        successMessage: false,
        success: res => {
            const { data } = res
            if (!data) {
                return
            }
            if (callback) {
                callback(data)
            } else {
                data.forEach(item => {
                    const { tableFieldName, fieldInputType, fieldDefaultValue } = item
                    if (!this[field][tableFieldName]) {
                        this[field][tableFieldName] = (fieldInputType === 'radio' && (fieldDefaultValue === '0' || fieldDefaultValue === '1'))
                            ? parseInt(fieldDefaultValue)
                            : fieldDefaultValue
                    }
                })
            }
        }
    })
}



// WEBPACK FOOTER //
// ./src/utils/initDefaultValue.js